module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 69
// module chunks = 1 2